import { CardScheme } from "@/types";

export enum CardFlag {
  VISA = "visa",
  MASTERCARD = "mastercard",
  AMEX = "amex",
  MADA = "mada",
  APPLE_PAY = "apple_pay",
  KNET = "knet",
  NEW = "new",
}

interface CardIconProps {
  type: CardFlag;
}

export const cardIconByScheme = (scheme: CardScheme) => (
  <CardIcon
    type={
      new Map<CardScheme, CardFlag>([
        [CardScheme.MASTERCARD, CardFlag.MASTERCARD],
        [CardScheme.VISA, CardFlag.VISA],
        [CardScheme.AMEX, CardFlag.AMEX],
        [CardScheme.MADA, CardFlag.MADA],
        [CardScheme.KNET, CardFlag.KNET],
      ]).get(scheme) ?? CardFlag.NEW
    }
  />
);

export default function CardIcon({ type }: CardIconProps) {
  switch (type) {
    case CardFlag.VISA:
      return (
        <svg
          width="42"
          height="24"
          viewBox="0 0 42 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="42" height="24" rx="4" fill="#E7EBFA" />
          <path
            d="M24.535 7.10608C22.407 7.10608 20.5056 8.21785 20.5056 10.2719C20.5056 12.6276 23.878 12.7903 23.878 13.9737C23.878 14.472 23.312 14.918 22.344 14.918C20.9709 14.918 19.9446 14.2948 19.9446 14.2948L19.5055 16.3676C19.5055 16.3676 20.6878 16.894 22.257 16.894C24.584 16.894 26.415 15.7277 26.415 13.6385C26.415 11.1493 23.028 10.9914 23.028 9.89302C23.028 9.50269 23.493 9.075 24.458 9.075C25.547 9.075 26.435 9.52828 26.435 9.52828L26.864 7.5263C26.864 7.5263 25.898 7.10608 24.535 7.10608V7.10608ZM5.0662 7.25717L5.0146 7.55936C5.0146 7.55936 5.9099 7.72451 6.7162 8.05395C7.7544 8.43172 7.8284 8.65163 8.0032 9.33469L9.9085 16.7382H12.4626L16.3974 7.25717H13.8492L11.3209 13.7034L10.2891 8.23927C10.1945 7.61391 9.7153 7.25717 9.1286 7.25717H5.0662V7.25717ZM17.4221 7.25717L15.4231 16.7382H17.8531L19.8451 7.25717H17.4221V7.25717ZM30.975 7.25717C30.389 7.25717 30.078 7.57338 29.851 8.12595L26.291 16.7382H28.839L29.332 15.3028H32.436L32.736 16.7382H34.985L33.023 7.25717H30.975V7.25717ZM31.306 9.81866L32.062 13.3764H30.038L31.306 9.81866V9.81866Z"
            fill="#1434CB"
          />
        </svg>
      );

    case CardFlag.MASTERCARD:
      return (
        <svg
          width="42"
          height="24"
          viewBox="0 0 42 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="42" height="24" rx="4" fill="#FEF5E8" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.0254 19.0757H25.8652V4.92426H18.0254V19.0757Z"
            fill="#FF5F00"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.5233 12.0001C18.5233 9.12916 19.8615 6.57217 21.9454 4.92443C20.4212 3.71918 18.4984 3.00018 16.4083 3.00018C11.4602 3.00018 7.44922 7.02967 7.44922 12.0001C7.44922 16.9706 11.4602 21.0001 16.4083 21.0001C18.4984 21.0001 20.4212 20.2811 21.9454 19.0759C19.8615 17.4279 18.5233 14.8711 18.5233 12.0001Z"
            fill="#EB001B"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M36.1618 17.5769V17.2277H36.0709L35.9666 17.4679L35.8621 17.2277H35.7713V17.5769H35.8352V17.3134L35.9333 17.5407H35.9997L36.0978 17.3129V17.5769H36.1618ZM35.5866 17.5769V17.2872H35.7031V17.2282H35.4069V17.2872H35.5231V17.5769H35.5866ZM36.4415 12C36.4415 16.9704 32.4303 20.9999 27.4825 20.9999C25.3923 20.9999 23.4692 20.2809 21.9453 19.0757C24.0292 17.4279 25.3675 14.871 25.3675 12C25.3675 9.12923 24.0292 6.57224 21.9453 4.92424C23.4692 3.719 25.3923 3 27.4825 3C32.4303 3 36.4415 7.02948 36.4415 12Z"
            fill="#F79E1B"
          />
        </svg>
      );

    case CardFlag.AMEX:
      return (
        <svg
          width="42"
          height="24"
          viewBox="0 0 46 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_4486_15840)">
            <rect y="0.5" width="46" height="29" rx="2.74871" fill="#3C97EB" />
            <g filter="url(#filter0_d_4486_15840)">
              <circle
                cx="56.6319"
                cy="36"
                r="50"
                transform="rotate(180 56.6319 36)"
                fill="#3C97EB"
              />
            </g>
            <rect
              x="3.95074"
              y="17.3315"
              width="1.49845"
              height="1.5"
              rx="0.749226"
              fill="white"
              fillOpacity="0.5"
            />
            <rect
              x="5.44922"
              y="17.3315"
              width="1.49845"
              height="1.5"
              rx="0.749226"
              fill="white"
              fillOpacity="0.5"
            />
            <rect
              x="6.94763"
              y="17.3315"
              width="1.49845"
              height="1.5"
              rx="0.749226"
              fill="white"
              fillOpacity="0.5"
            />
            <rect
              x="8.44611"
              y="17.3315"
              width="1.49845"
              height="1.5"
              rx="0.749226"
              fill="white"
              fillOpacity="0.5"
            />
            <rect
              x="11.0734"
              y="17.3315"
              width="1.49845"
              height="1.5"
              rx="0.749226"
              fill="white"
              fillOpacity="0.5"
            />
            <rect
              x="12.572"
              y="17.3315"
              width="1.49845"
              height="1.5"
              rx="0.749226"
              fill="white"
              fillOpacity="0.5"
            />
            <rect
              x="14.0703"
              y="17.3315"
              width="1.49845"
              height="1.5"
              rx="0.749226"
              fill="white"
              fillOpacity="0.5"
            />
            <rect
              x="15.5688"
              y="17.3315"
              width="1.49845"
              height="1.5"
              rx="0.749226"
              fill="white"
              fillOpacity="0.5"
            />
            <rect
              x="18.196"
              y="17.3315"
              width="1.49845"
              height="1.5"
              rx="0.749226"
              fill="white"
              fillOpacity="0.5"
            />
            <rect
              x="19.6943"
              y="17.3315"
              width="1.49845"
              height="1.5"
              rx="0.749226"
              fill="white"
              fillOpacity="0.5"
            />
            <rect
              x="21.1929"
              y="17.3315"
              width="1.49845"
              height="1.5"
              rx="0.749226"
              fill="white"
              fillOpacity="0.5"
            />
            <rect
              x="22.6912"
              y="17.3315"
              width="1.49845"
              height="1.5"
              rx="0.749226"
              fill="white"
              fillOpacity="0.5"
            />
            <rect
              x="3.95074"
              y="24.6859"
              width="1.12883"
              height="19.98"
              rx="0.564417"
              transform="rotate(-90 3.95074 24.6859)"
              fill="white"
              fillOpacity="0.5"
            />
            <rect
              x="26.9308"
              y="24.686"
              width="1.12883"
              height="1.97546"
              rx="0.564417"
              transform="rotate(-90 26.9308 24.686)"
              fill="white"
              fillOpacity="0.5"
            />
            <rect
              x="28.9062"
              y="24.6859"
              width="1.12883"
              height="1.97546"
              rx="0.564417"
              transform="rotate(-90 28.9062 24.6859)"
              fill="white"
              fillOpacity="0.5"
            />
            <path
              d="M32.3817 23.3716L31.8817 24.8716"
              stroke="white"
              strokeOpacity="0.5"
              strokeWidth="0.25"
            />
            <rect
              x="33.3817"
              y="24.686"
              width="1.12883"
              height="1.97546"
              rx="0.564417"
              transform="rotate(-90 33.3817 24.686)"
              fill="white"
              fillOpacity="0.5"
            />
            <rect
              x="35.3571"
              y="24.6859"
              width="1.12883"
              height="1.97546"
              rx="0.564417"
              transform="rotate(-90 35.3571 24.6859)"
              fill="white"
              fillOpacity="0.5"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.94293 5.52273C3.94293 5.02673 4.34502 4.62463 4.84103 4.62463H9.09391C9.58991 4.62463 9.992 5.02673 9.992 5.52273V6.68429L7.97222 6.68429V6.4598C7.97222 6.16865 7.73619 5.93262 7.44504 5.93262C7.27842 5.93262 7.12986 6.00991 7.03325 6.1306V4.62476L6.90146 4.62476V6.12958C6.80483 6.00948 6.65663 5.93262 6.49049 5.93262C6.19933 5.93262 5.9633 6.16865 5.9633 6.4598V6.68429L3.94293 6.68429V5.52273ZM3.94293 6.81608V7.97724C3.94293 8.47324 4.34502 8.87533 4.84103 8.87533H6.90146V7.5808C6.80483 7.7009 6.65663 7.77776 6.49049 7.77776C6.19933 7.77776 5.9633 7.54173 5.9633 7.25058V6.81608L3.94293 6.81608ZM7.97222 6.81608V7.25058C7.97222 7.54173 7.73619 7.77776 7.44504 7.77776C7.27842 7.77776 7.12986 7.70047 7.03325 7.57978V8.87533H9.09391C9.58991 8.87533 9.992 8.47324 9.992 7.97724V6.81608L7.97222 6.81608Z"
              fill="white"
              fillOpacity="0.5"
            />
            <path
              d="M40.0055 6.38514H40.9244V4.25H39.9244V4.5473L39.7353 4.25H38.8704V4.62838L38.7082 4.25H37.1136C37.0596 4.25 37.0055 4.27703 36.9515 4.27703C36.8974 4.27703 36.8704 4.30405 36.8163 4.33108C36.7623 4.35811 36.7353 4.35811 36.6812 4.38514V4.25H32.1136L31.9785 4.60135L31.8434 4.25H30.7623V4.62838L30.6001 4.25H29.7353L29.3569 5.16892V6.38514H29.9785L30.0866 6.08784H30.3028L30.4109 6.38514H35.1677V6.11486L35.3569 6.38514H36.6812V6.22297C36.7082 6.25 36.7623 6.25 36.7893 6.27703C36.8163 6.30405 36.8704 6.30405 36.8974 6.33108C36.9515 6.35811 37.0055 6.35811 37.0596 6.35811H38.0325L38.1407 6.06081H38.3569L38.465 6.35811H39.7893V6.08784L40.0055 6.38514ZM41.492 9.08784V7.08784H34.0596L33.8704 7.35811L33.6812 7.08784H31.519V9.22297H33.6812L33.8704 8.9527L34.0596 9.22297H35.4109V8.76351H35.3569C35.5461 8.76351 35.7082 8.73649 35.8434 8.68243V9.25H36.8163V8.97973L37.0055 9.25H41.0325C41.1947 9.19595 41.3569 9.16892 41.492 9.08784Z"
              fill="white"
              fillOpacity="0.1"
            />
            <path
              d="M41.0324 8.57454H40.3027V8.87183H41.0054C41.3027 8.87183 41.4919 8.68264 41.4919 8.41237C41.4919 8.1421 41.3297 8.00697 41.0595 8.00697H40.7351C40.654 8.00697 40.6 7.95291 40.6 7.87183C40.6 7.79075 40.654 7.7367 40.7351 7.7367H41.3568L41.4919 7.4394H40.7622C40.4649 7.4394 40.2757 7.62859 40.2757 7.87183C40.2757 8.1421 40.4378 8.27724 40.7081 8.27724H41.0324C41.1135 8.27724 41.1676 8.33129 41.1676 8.41237C41.1946 8.52048 41.1405 8.57454 41.0324 8.57454ZM39.7081 8.57454H38.9784V8.87183H39.6811C39.9784 8.87183 40.1676 8.68264 40.1676 8.41237C40.1676 8.1421 40.0054 8.00697 39.7351 8.00697H39.4108C39.3297 8.00697 39.2757 7.95291 39.2757 7.87183C39.2757 7.79075 39.3297 7.7367 39.4108 7.7367H40.0324L40.1676 7.4394H39.4378C39.1405 7.4394 38.9513 7.62859 38.9513 7.87183C38.9513 8.1421 39.1135 8.27724 39.3838 8.27724H39.7081C39.7892 8.27724 39.8432 8.33129 39.8432 8.41237C39.8703 8.52048 39.7892 8.57454 39.7081 8.57454ZM38.7622 7.70967V7.41237H37.627V8.84481H38.7622V8.54751H37.9513V8.25021H38.7351V7.95291H37.9513V7.68264H38.7622V7.70967ZM36.9243 7.70967C37.0595 7.70967 37.1135 7.79075 37.1135 7.87183C37.1135 7.95291 37.0595 8.034 36.9243 8.034H36.5189V7.68264L36.9243 7.70967ZM36.5189 8.33129H36.6811L37.1135 8.84481H37.5189L37.0324 8.30427C37.2757 8.25021 37.4108 8.08805 37.4108 7.87183C37.4108 7.60156 37.2216 7.41237 36.9243 7.41237H36.1676V8.84481H36.4919L36.5189 8.33129ZM35.654 7.89886C35.654 8.00697 35.6 8.08805 35.4649 8.08805H35.0324V7.70967H35.4378C35.573 7.70967 35.654 7.79075 35.654 7.89886ZM34.7081 7.41237V8.84481H35.0324V8.35832H35.4649C35.7622 8.35832 35.9784 8.16913 35.9784 7.87183C35.9784 7.60156 35.7892 7.38535 35.4919 7.38535L34.7081 7.41237ZM34.2216 8.84481H34.627L34.0595 8.11508L34.627 7.41237H34.2216L33.8703 7.87183L33.5189 7.41237H33.1135L33.6811 8.11508L33.1135 8.81778H33.5189L33.8703 8.35832L34.2216 8.84481ZM33.0054 7.70967V7.41237H31.8703V8.84481H33.0054V8.54751H32.1946V8.25021H32.9784V7.95291H32.1946V7.68264H33.0054V7.70967ZM39.573 5.16913L40.1405 6.034H40.5459V4.60156H40.2216V5.54751L40.1405 5.41237L39.627 4.60156H39.1946V6.034H39.5189V5.06102L39.573 5.16913ZM38.1676 5.1421L38.2757 4.84481L38.3838 5.1421L38.5189 5.46643H38.0324L38.1676 5.1421ZM38.7351 6.034H39.0865L38.4649 4.60156H38.0324L37.4108 6.034H37.7622L37.8973 5.7367H38.6L38.7351 6.034ZM37.2216 6.034L37.3568 5.7367H37.2757C37.0324 5.7367 36.8973 5.57454 36.8973 5.33129V5.30427C36.8973 5.06102 37.0324 4.89886 37.2757 4.89886H37.627V4.60156H37.2486C36.8162 4.60156 36.573 4.89886 36.573 5.30427V5.33129C36.573 5.76372 36.8162 6.034 37.2216 6.034ZM36.0054 6.034H36.3297V4.62859H36.0054V6.034ZM35.3027 4.89886C35.4378 4.89886 35.4919 4.97994 35.4919 5.06102C35.4919 5.1421 35.4378 5.22318 35.3027 5.22318H34.8973V4.87183L35.3027 4.89886ZM34.8973 5.52048H35.0595L35.4919 6.034H35.8973L35.4108 5.49345C35.654 5.4394 35.7892 5.27724 35.7892 5.06102C35.7892 4.79075 35.6 4.60156 35.3027 4.60156H34.5459V6.034H34.8703L34.8973 5.52048ZM34.3027 4.89886V4.60156H33.1676V6.034H34.3027V5.7367H33.4919V5.4394H34.2757V5.1421H33.4919V4.87183H34.3027V4.89886ZM31.8432 6.034H32.1405L32.5459 4.87183V6.034H32.8703V4.60156H32.3297L32.0054 5.57454L31.6811 4.60156H31.1405V6.034H31.4649V4.87183L31.8432 6.034ZM30.0865 5.1421L30.1946 4.84481L30.3027 5.1421L30.4378 5.46643H29.9513L30.0865 5.1421ZM30.654 6.034H31.0054L30.3838 4.60156H29.9784L29.3568 6.034H29.7081L29.8432 5.7367H30.5459L30.654 6.034Z"
              fill="white"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_4486_15840"
              x="-17.3681"
              y="-34"
              width="148"
              height="148"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="12" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0.028 0 0 0 0 0.7 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_4486_15840"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_4486_15840"
                result="shape"
              />
            </filter>
            <clipPath id="clip0_4486_15840">
              <rect y="0.5" width="46" height="29" rx="2.74871" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case CardFlag.MADA:
      return (
        <svg
          width="42"
          height="24"
          viewBox="0 0 42 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="42" height="24" rx="4" fill="#E9F5FB" />
          <path
            d="M18.6905 12.7687H6V16.9964H18.6905V12.7687Z"
            fill="#84B740"
          />
          <path d="M18.6905 7H6V11.2314H18.6905V7Z" fill="#259BD6" />
          <path
            d="M31.3811 16.1373L31.3246 16.1486C31.1287 16.1863 31.0571 16.2013 30.9139 16.2013C30.5823 16.2013 30.1905 16.0318 30.1905 15.233C30.1905 14.8223 30.2583 14.2759 30.8762 14.2759H30.88C30.9855 14.2834 31.1061 14.2947 31.3322 14.3626L31.3811 14.3776V16.1373ZM31.4829 12.1545L31.3811 12.1734V13.6504L31.2907 13.624L31.2643 13.6165C31.1626 13.5864 30.929 13.5185 30.7029 13.5185C29.467 13.5185 29.207 14.453 29.207 15.2367C29.207 16.3106 29.8099 16.9285 30.8612 16.9285C31.3058 16.9285 31.6336 16.8833 31.9652 16.7741C32.2704 16.6761 32.3796 16.5367 32.3796 16.239V12.0001C32.0857 12.0528 31.7805 12.1056 31.4829 12.1545Z"
            fill="#27292D"
          />
          <path
            d="M35.0547 16.1636L35.0019 16.1787L34.8135 16.2277C34.6364 16.2729 34.4782 16.2993 34.3576 16.2993C34.0675 16.2993 33.8941 16.1561 33.8941 15.9112C33.8941 15.7529 33.9657 15.4854 34.4405 15.4854H35.0547V16.1636ZM34.6214 13.4997C34.2408 13.4997 33.8489 13.5675 33.3629 13.7182L33.0464 13.8124L33.1519 14.5283L33.4608 14.4266C33.7849 14.3211 34.188 14.2533 34.4895 14.2533C34.6251 14.2533 35.0396 14.2533 35.0396 14.7017V14.8976H34.4631C33.4118 14.8976 32.9258 15.233 32.9258 15.9526C32.9258 16.5668 33.3742 16.9361 34.1278 16.9361C34.3614 16.9361 34.6854 16.8909 34.9642 16.823L34.9793 16.8193L34.9944 16.823L35.0886 16.8381C35.3825 16.8909 35.6877 16.9436 35.9854 17.0001V14.6489C35.9854 13.8878 35.5257 13.4997 34.6214 13.4997Z"
            fill="#27292D"
          />
          <path
            d="M27.7344 16.1636L27.6816 16.1787L27.4932 16.2277C27.3161 16.2729 27.1616 16.2993 27.0373 16.2993C26.7472 16.2993 26.5738 16.1561 26.5738 15.9112C26.5738 15.7529 26.6454 15.4854 27.1164 15.4854H27.7306L27.7344 16.1636ZM27.3048 13.4997C26.9205 13.4997 26.5324 13.5675 26.0463 13.7182L25.7298 13.8124L25.8353 14.5283L26.1443 14.4266C26.4683 14.3211 26.8715 14.2533 27.1729 14.2533C27.3086 14.2533 27.7231 14.2533 27.7231 14.7017V14.8976H27.1466C26.0953 14.8976 25.6055 15.233 25.6055 15.9526C25.6055 16.5668 26.0539 16.9361 26.8112 16.9361C27.0448 16.9361 27.3689 16.8909 27.6477 16.823L27.6628 16.8193L27.6778 16.823L27.7683 16.8381C28.0659 16.8909 28.3674 16.9436 28.665 17.0039V14.6527C28.6688 13.884 28.2091 13.4997 27.3048 13.4997Z"
            fill="#27292D"
          />
          <path
            d="M23.7668 13.5072C23.2882 13.5072 22.8926 13.6655 22.7456 13.7333L22.708 13.7522L22.6741 13.7258C22.4706 13.5788 22.1729 13.5035 21.7584 13.5035C21.393 13.5035 21.0501 13.5562 20.677 13.6655C20.3568 13.7635 20.2324 13.918 20.2324 14.2081V16.8946H21.2347V14.4116L21.2837 14.3965C21.4872 14.3287 21.6077 14.3174 21.7245 14.3174C22.0147 14.3174 22.1616 14.4718 22.1616 14.7733V16.8984H23.1488V14.7318C23.1488 14.6037 23.1224 14.5284 23.1187 14.5133L23.0848 14.4492L23.1526 14.4191C23.3033 14.3513 23.4691 14.3174 23.6424 14.3174C23.8421 14.3174 24.0795 14.3965 24.0795 14.7733V16.8984H25.0629V14.6753C25.0629 13.8878 24.6409 13.5072 23.7668 13.5072Z"
            fill="#27292D"
          />
          <path
            d="M34.3148 9.75814C34.1679 9.75814 33.923 9.74307 33.7308 9.70539L33.6743 9.69409V8.24342C33.6743 8.12285 33.6517 8.04749 33.6479 8.03619L33.6178 7.9759L33.6818 7.94952C33.6969 7.94199 33.712 7.93822 33.7308 7.93068L33.7421 7.92315C33.7647 7.91561 33.7873 7.90808 33.8099 7.90054C33.8212 7.89677 33.8288 7.893 33.8363 7.893C34.0586 7.83272 34.2621 7.84025 34.3525 7.83272H34.3563C34.9705 7.83272 35.0421 8.37907 35.0421 8.78978C35.0383 9.58858 34.6427 9.75814 34.3148 9.75814ZM34.3111 7C34.3035 7 34.2922 7 34.2847 7C33.7082 7 33.1166 7.15825 32.9056 7.46723C32.7926 7.61794 32.7285 7.80634 32.7248 8.02865V9.52453C32.7248 9.65264 32.6984 9.70162 32.6946 9.71293L32.6607 9.77698H30.8408V8.73703H30.837C30.8144 7.64055 30.1663 7.03768 29.2281 7.03768H29.1188H28.3125C28.2748 7.3052 28.2447 7.4936 28.207 7.76113H29.1188C29.5974 7.76113 29.8498 8.16807 29.8498 8.79355V9.84104L29.7858 9.80712C29.7745 9.80336 29.6953 9.77698 29.571 9.77698H27.996C27.9658 9.97668 27.9282 10.2367 27.8867 10.4967H32.7285C32.8943 10.4627 33.0865 10.4326 33.2523 10.4062C33.4972 10.5268 33.9531 10.5909 34.2659 10.5909C35.3171 10.5909 35.9991 9.88625 35.9991 8.80108C35.9954 7.72721 35.336 7.02261 34.3111 7Z"
            fill="#27292D"
          />
          <path
            d="M25.8241 10.9375H25.8693C26.9205 10.9375 27.4104 10.5908 27.4104 9.73549C27.4104 9.12132 26.962 8.63148 26.2084 8.63148H25.24C24.9499 8.63148 24.7766 8.4657 24.7766 8.18687C24.7766 7.99847 24.8482 7.76486 25.3229 7.76486H27.4405C27.4857 7.4898 27.5083 7.31647 27.5498 7.04141H25.3493C24.3244 7.04141 23.8082 7.47096 23.8082 8.18687C23.8082 8.89524 24.2566 9.2645 25.0102 9.2645H25.9786C26.2687 9.2645 26.442 9.49434 26.442 9.73549C26.442 9.89375 26.3704 10.2216 25.8994 10.2216H25.7374L22.6364 10.214H22.0712C21.5927 10.214 21.2573 9.94273 21.2573 9.31348V8.88017C21.2573 8.22455 21.5173 7.81761 22.0712 7.81761H22.9906C23.032 7.53878 23.0584 7.36169 23.0961 7.09793H21.9506H21.8413C20.9031 7.09793 20.255 7.72718 20.2324 8.82365V8.8651V9.31348C20.255 10.41 20.9031 10.9337 21.8413 10.9337H21.9506H22.757L24.4375 10.9375H25.4397H25.8241Z"
            fill="#27292D"
          />
        </svg>
      );

    case CardFlag.APPLE_PAY:
      return (
        <svg
          width="41"
          height="25"
          viewBox="0 0 41 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.835938"
            y="1.21417"
            width="39"
            height="23"
            rx="3.5"
            fill="white"
          />
          <rect
            x="0.835938"
            y="1.21417"
            width="39"
            height="23"
            rx="3.5"
            stroke="black"
          />
          <path
            d="M12.1689 9.34707C12.2494 9.34707 12.3866 9.35988 12.5804 9.38548C12.7743 9.41108 12.9864 9.48424 13.2169 9.60494C13.451 9.72198 13.6631 9.91767 13.8533 10.192C13.8423 10.203 13.7893 10.2432 13.6942 10.3127C13.5991 10.3785 13.493 10.4773 13.376 10.609C13.2589 10.737 13.1565 10.9016 13.0687 11.1028C12.9809 11.3003 12.9371 11.5362 12.9371 11.8105C12.9371 12.1251 12.9919 12.3921 13.1016 12.6115C13.215 12.831 13.3449 13.0084 13.4912 13.1437C13.6412 13.2754 13.7728 13.3723 13.8862 13.4345C14.0033 13.4967 14.0654 13.5296 14.0728 13.5333C14.0691 13.5479 14.0215 13.6777 13.9301 13.9228C13.8423 14.1679 13.696 14.4404 13.4912 14.7403C13.312 15 13.1181 15.2396 12.9096 15.459C12.7048 15.6785 12.4579 15.7882 12.1689 15.7882C11.9751 15.7882 11.816 15.7608 11.6916 15.7059C11.5673 15.6474 11.4392 15.5907 11.3076 15.5358C11.1759 15.4773 10.9985 15.448 10.7754 15.448C10.5596 15.448 10.3785 15.4773 10.2322 15.5358C10.0896 15.5944 9.9524 15.6529 9.82073 15.7114C9.69271 15.7699 9.54092 15.7992 9.36535 15.7992C9.09834 15.7992 8.86425 15.6931 8.66308 15.481C8.46191 15.2688 8.25525 15.0146 8.04311 14.7183C7.79804 14.3672 7.58773 13.9393 7.41216 13.4345C7.24025 12.9261 7.1543 12.414 7.1543 11.8983C7.1543 11.346 7.25854 10.8833 7.46703 10.5102C7.67551 10.1335 7.94252 9.85 8.26805 9.6598C8.59724 9.46595 8.9374 9.36902 9.28854 9.36902C9.47508 9.36902 9.65065 9.40011 9.81524 9.46229C9.97984 9.52081 10.1335 9.58116 10.2761 9.64334C10.4224 9.70552 10.5541 9.73662 10.6711 9.73662C10.7845 9.73662 10.9162 9.7037 11.0662 9.63786C11.2161 9.57202 11.3844 9.50801 11.5709 9.44583C11.7575 9.37999 11.9568 9.34707 12.1689 9.34707ZM11.8672 8.65029C11.7245 8.8222 11.5453 8.96668 11.3295 9.08372C11.1137 9.19711 10.9089 9.2538 10.715 9.2538C10.6748 9.2538 10.6364 9.25015 10.5998 9.24283C10.5962 9.23186 10.5925 9.21174 10.5888 9.18248C10.5852 9.15322 10.5834 9.12213 10.5834 9.08921C10.5834 8.86975 10.6309 8.65761 10.726 8.45278C10.8211 8.24429 10.929 8.07238 11.0497 7.93705C11.2033 7.75416 11.3972 7.60237 11.6313 7.48167C11.8654 7.36097 12.0885 7.29696 12.3006 7.28964C12.3116 7.33719 12.3171 7.39389 12.3171 7.45972C12.3171 7.67918 12.275 7.89316 12.1909 8.10164C12.1068 8.30647 11.9989 8.48935 11.8672 8.65029Z"
            fill="#16181D"
          />
          <path
            d="M15.2968 15.7388V7.61205H18.2529C18.7984 7.61205 19.2783 7.71387 19.6929 7.91749C20.1146 8.11384 20.4419 8.40473 20.6746 8.79016C20.9073 9.16832 21.0237 9.62284 21.0237 10.1537C21.0237 10.6773 20.9037 11.1282 20.6637 11.5064C20.431 11.8845 20.1074 12.1754 19.6929 12.379C19.2783 12.5827 18.7984 12.6845 18.2529 12.6845H16.584V15.7388H15.2968ZM16.584 11.5391H18.2857C18.5766 11.5391 18.8311 11.4809 19.0493 11.3646C19.2674 11.2482 19.4383 11.0882 19.562 10.8846C19.6856 10.6737 19.7474 10.4264 19.7474 10.1428C19.7474 9.85919 19.6856 9.61557 19.562 9.41194C19.4383 9.20105 19.2674 9.04106 19.0493 8.93197C18.8311 8.81562 18.5766 8.75744 18.2857 8.75744H16.584V11.5391Z"
            fill="#16181D"
          />
          <path
            d="M23.6126 15.8697C23.2126 15.8697 22.8599 15.8006 22.5544 15.6625C22.2563 15.517 22.0236 15.3207 21.8563 15.0734C21.689 14.8189 21.6054 14.5207 21.6054 14.1789C21.6054 13.8589 21.6745 13.5717 21.8127 13.3172C21.9581 13.0626 22.1799 12.8481 22.4781 12.6736C22.7762 12.499 23.1508 12.3754 23.6016 12.3027L25.6524 11.9645V12.9354L23.8416 13.2517C23.5144 13.3099 23.2744 13.4153 23.1217 13.5681C22.969 13.7135 22.8926 13.9026 22.8926 14.1353C22.8926 14.3607 22.9762 14.5462 23.1435 14.6916C23.318 14.8298 23.5398 14.8989 23.8089 14.8989C24.1434 14.8989 24.4343 14.8262 24.6816 14.6807C24.9361 14.5353 25.1325 14.3426 25.2706 14.1026C25.4088 13.8553 25.4779 13.5826 25.4779 13.2844V11.7682C25.4779 11.4773 25.3688 11.2409 25.1506 11.0591C24.9397 10.87 24.6561 10.7755 24.2998 10.7755C23.9725 10.7755 23.6853 10.8628 23.438 11.0373C23.198 11.2046 23.0199 11.4227 22.9035 11.6918L21.8781 11.1791C21.9872 10.8882 22.1654 10.6337 22.4126 10.4155C22.6599 10.1901 22.9471 10.0155 23.2744 9.89192C23.6089 9.76829 23.9616 9.70647 24.3325 9.70647C24.7979 9.70647 25.2088 9.79374 25.5652 9.96827C25.9288 10.1428 26.2088 10.3864 26.4051 10.6991C26.6087 11.0046 26.7105 11.3609 26.7105 11.7682V15.7388H25.5324V14.6698L25.7833 14.7025C25.6452 14.9425 25.467 15.1498 25.2488 15.3243C25.0379 15.4988 24.7943 15.6334 24.518 15.7279C24.2489 15.8225 23.9471 15.8697 23.6126 15.8697Z"
            fill="#16181D"
          />
          <path
            d="M28.6754 18.1387C28.53 18.1387 28.3845 18.1241 28.2391 18.0951C28.1009 18.0732 27.9737 18.0369 27.8573 17.986V16.9278C27.9446 16.9497 28.05 16.9678 28.1736 16.9824C28.2973 17.0042 28.4173 17.0151 28.5336 17.0151C28.8754 17.0151 29.1263 16.9388 29.2863 16.786C29.4536 16.6406 29.6026 16.4152 29.7335 16.1097L30.1263 15.2152L30.1044 16.2515L27.5519 9.83737H28.8718L30.7589 14.7571H30.3117L32.1879 9.83737H33.5188L30.9117 16.3824C30.7735 16.7315 30.5989 17.0369 30.3881 17.2987C30.1844 17.5678 29.9408 17.7751 29.6572 17.9205C29.3808 18.066 29.0536 18.1387 28.6754 18.1387Z"
            fill="#16181D"
          />
        </svg>
      );

    case CardFlag.KNET:
      return (
        <svg
          width="42"
          height="24"
          viewBox="0 0 24 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 2a2 2 0 012-2h20a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2z"
            fill="#E5EEF5"
          />
          <path
            d="M19.414 5.06H4V2h15.414v3.059zm0 .296H4v4.811h15.414V5.356zm0 8.167H4v-3.059h15.414v3.06z"
            fill="#00549A"
          />
          <path
            d="M16.97 4.609h.454v-.283h-.454v.283zm-.579 0h.454v-.283h-.454v.283zm-6.352-.812h-.277v-.398h-.56v.398H5.161l-.05-.105.384-.499v-.356h-.55l-.608.79.346.74h5.915v-.968h-.56v.398zm.52-.917h-.454v.282h.454V2.88z"
            fill="#fff"
          />
          <path
            d="M6.302 2.965h-.454v.282h.454v-.282zm.589 0h-.454v.282h.454v-.282zm11.836.319h-1.653l-.251-.21h1.756l-.183-.319H16.19l-.035.113.757.631h1.303v.168h-1.408l-.478-.398h-.955v.843h-1.572v-.345h1.326v-.498h-2.144V4.52h2.956v-.665l.334.277h2.474l.347-.355v-.116l-.369-.378zm-7.577.726h1.047v-.457H11.15v.457z"
            fill="#fff"
          />
          <path
            d="M17.376 9.692l-2.83-2.128 2.78-1.703h-4.98L9.91 7.353V5.86H6.437v3.831H9.91V7.698l2.23 1.994h5.236z"
            fill="#FFF200"
          />
          <path
            d="M5.745 13.112v-1.898h.498v.225a.692.692 0 01.574-.276c.21 0 .367.055.471.163.104.11.156.273.156.492v1.294h-.508v-1.147c0-.136-.023-.234-.069-.292-.046-.058-.12-.087-.224-.087a.38.38 0 00-.285.107.401.401 0 00-.105.293v1.126h-.508zm5.543-1.172h.748a.434.434 0 00-.103-.293c-.063-.067-.154-.1-.273-.1a.341.341 0 00-.261.1.47.47 0 00-.11.293zm.74.572h.507a.811.811 0 01-.31.47.937.937 0 01-.568.171c-.275 0-.493-.092-.654-.277-.16-.184-.24-.434-.24-.75 0-.31.079-.556.237-.735.158-.18.375-.269.65-.269.29 0 .515.088.674.265.158.176.237.427.237.753v.082a.458.458 0 01-.005.051h-1.268c.007.149.043.261.11.337.065.076.16.114.283.114a.405.405 0 00.215-.052.35.35 0 00.133-.16zm5.579.836a8.885 8.885 0 00-.29.01c-.194 0-.327-.036-.399-.109-.072-.072-.107-.216-.107-.43v-1.027h-.252v-.356h.252v-.52h.503v.52h.293v.356h-.293v1.051c0 .05.01.083.033.099.022.016.067.023.136.023h.124v.383z"
            fill="#fff"
          />
        </svg>
      );

    case CardFlag.NEW:
    default:
      return (
        <svg
          width="42"
          height="24"
          viewBox="0 0 42 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="42" height="24" rx="4" fill="#F4F6F9" />
          <path
            d="M20.4668 15.2667H21.5668V12.5667H24.2668V11.4667H21.5668V8.73334H20.4668V11.4667H17.7335V12.5667H20.4668V15.2667ZM21.0023 18.5333C20.0989 18.5333 19.2495 18.3619 18.4541 18.019C17.6589 17.6761 16.9671 17.2108 16.3788 16.623C15.7905 16.0352 15.3247 15.344 14.9816 14.5493C14.6384 13.7548 14.4668 12.9057 14.4668 12.0022C14.4668 11.096 14.6386 10.2439 14.9821 9.44601C15.3257 8.64823 15.7919 7.95429 16.3808 7.36417C16.9697 6.77395 17.6609 6.31017 18.4545 5.97284C19.2479 5.6354 20.0957 5.46667 20.998 5.46667C21.9041 5.46667 22.756 5.63523 23.5538 5.97234C24.3515 6.30945 25.0455 6.7729 25.6358 7.36268C26.2261 7.95245 26.69 8.64601 27.0273 9.44334C27.3647 10.2407 27.5335 11.0926 27.5335 11.9992C27.5335 12.9057 27.3649 13.7548 27.0278 14.5463C26.6907 15.3378 26.2273 16.0282 25.6376 16.6177C25.048 17.2071 24.3546 17.6738 23.5575 18.0177C22.7604 18.3615 21.9086 18.5333 21.0023 18.5333ZM21.0001 17.4333C22.5169 17.4333 23.8017 16.907 24.8545 15.8543C25.9071 14.8016 26.4335 13.5168 26.4335 12C26.4335 10.4832 25.9071 9.19845 24.8545 8.14567C23.8017 7.09301 22.5169 6.56667 21.0001 6.56667C19.4834 6.56667 18.1986 7.09301 17.1458 8.14567C16.0931 9.19845 15.5668 10.4832 15.5668 12C15.5668 13.5168 16.0931 14.8016 17.1458 15.8543C18.1986 16.907 19.4834 17.4333 21.0001 17.4333Z"
            fill="#16181D"
          />
        </svg>
      );
  }
}
